import { Message } from "@apis:message/message";
import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { alpha, Box, useTheme } from "@mui/material";
import { AIResponse } from "@pages:app/talk/shared/AIResponse";

interface BotMessageProps {
  showReferences: boolean;
  text: string;
  references: Message["GET_ONE"]["Response"]["docs"];
  setShowReferences: (
    value: ((prevState: boolean) => boolean) | boolean,
  ) => void;
  messageId: string | null | undefined;
}

export const BotMessage = ({
  showReferences,
  setShowReferences,
  text,
  references,
  messageId,
}: BotMessageProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "10px",
          left: "-3rem",
        }}
      >
        <SVGInternalIcon
          icon="botNav"
          sx={{
            width: 30,
            height: 30,
            backgroundColor: alpha(theme.palette.primary.main, 0.06),
            boxShadow: `0px 8px 24px 0px ${alpha(theme.palette.primary.main, 0.16)}`,
            "& .eye": {
              fill: theme.palette.primary.main,
            },
          }}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: alpha(theme.palette.primary.main, 0.06),
          borderRadius: "30px",
          padding: "1rem 2rem",
          borderBottomLeftRadius: showReferences ? "0" : "30px",
          width: "100%",
        }}
      >
        <AIResponse
          answer={text}
          references={references}
          setShowReferences={setShowReferences}
          showReferences={showReferences}
          messageId={messageId}
        />
      </Box>
    </Box>
  );
};
